/**
 * 빌드 정보 서비스
 * 빌드 시점에 생성된 build-info.json 파일에서 정보를 가져옵니다.
 */

let buildInfoCache = null;

export const getBuildInfo = async () => {
  // 캐시된 정보가 있으면 반환
  if (buildInfoCache) {
    return buildInfoCache;
  }

  try {
    // PUBLIC_URL을 고려한 경로 계산
    const publicUrl = process.env.PUBLIC_URL || '';
    const buildInfoUrl = `${publicUrl}/build-info.json`;
    const response = await fetch(buildInfoUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const buildInfo = await response.json();
    buildInfoCache = buildInfo;
    return buildInfo;
  } catch (error) {
    // 기본값 반환
    return {
      version: 'unknown',
      buildDate: 'unknown',
      buildTimestamp: 0,
      gitHash: 'unknown',
      gitBranch: 'unknown',
      nodeVersion: 'unknown',
      platform: 'unknown',
      copyright: {
        year: new Date().getFullYear(),
        holder: 'ypkim'
      }
    };
  }
};

export const formatBuildDate = (buildDate) => {
  if (!buildDate || buildDate === 'unknown') {
    return 'Unknown';
  }
  
  try {
    const date = new Date(buildDate);
    return date.toLocaleString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short'
    });
  } catch (error) {
    return buildDate;
  }
};

export const formatTimeSince = (buildTimestamp) => {
  if (!buildTimestamp || buildTimestamp === 0) {
    return 'Unknown';
  }
  
  try {
    const now = Date.now();
    const diffMs = now - buildTimestamp;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
    if (diffDays > 0) {
      return `${diffDays}일 전`;
    } else if (diffHours > 0) {
      return `${diffHours}시간 전`;
    } else if (diffMinutes > 0) {
      return `${diffMinutes}분 전`;
    } else {
      return '방금 전';
    }
  } catch (error) {
    return 'Unknown';
  }
};

export default {
  getBuildInfo,
  formatBuildDate,
  formatTimeSince
}; 